import {LOW_RATING_ADVANTAGE_DAMAGE_DICE_FACE_PENALTY} from "../../configs/lowRatingAdvantage";
import {checkIfNeutralPlayer} from "../players/checkIfNeutralPlayer";
import {getBotD6MinRoll} from "./getBotD6MinRoll";
import {checkIfBotPlayer} from "../players/checkIfBotPlayer";

const MAX_D6 = 6;

/**
 * Штраф к грани кости урона по форе новичкам (см. configs/lowRatingAdvantage):
 * отряд бота или нейтральный отряд бросает на 1 хуже, если в этом бою против
 * него стоит игрок с форой (player.hasLowRatingAdvantage — рейтинг ниже 500 на
 * старте партии). Зеркало +1 к полу против игрока под давлением ботов (см.
 * getBotCombatD6MinRoll), только в пользу человека.
 *
 * Действует именно против такого игрока, а не на всю партию: между собой боты
 * и нейтральные отряды бросают как раньше, и сильному соседу новичка фора не
 * достается. Отряд в ближнем бою может быть зажат сразу несколькими
 * противниками, а кости у него на бой одни — хватает одного игрока с форой.
 *
 * Нейтрального владельца в списке игроков нет: его узнают по id отряда
 * (isNeutralRoller) либо по заглушке, которую отдает getPlayerById.
 *
 * Чьи отряды бросают «за бота» — см. checkIfBotPlayer (признак устойчив к
 * маскам движка ботов: иначе один и тот же отряд получал бы разные кости у
 * разных исполнителей броска).
 *
 * Бот, чей уровень бонуса фиксирует d6 на 6 («божество», см. getBotD6MinRoll),
 * штрафа не получает: его кость урона всегда 0, и это правило важнее форы
 * (решение владельца). Встретиться они могут только в локальной партии. Если
 * в этом же бою против него и бот, кости у него обычные (см.
 * checkIfAnyOpponentIsBot) — и фора тогда действует, как у любого бота.
 *
 * @param {Object} [rollingPlayer] - владелец бросающего отряда
 * @param {Object|Object[]} [targetPlayers] - игрок-цель или все игроки, чьи
 *   отряды (или владения — цель выстрела) стоят в этом бою на другой стороне
 * @param {Object} [options]
 * @param {boolean} [options.isNeutralRoller] - бросает нейтральный отряд
 * @returns {number} штраф к грани: 0 или LOW_RATING_ADVANTAGE_DAMAGE_DICE_FACE_PENALTY
 */
export const getLowRatingAdvantageDicePenalty = (rollingPlayer, targetPlayers, {isNeutralRoller = false} = {}) => {
  if (!targetPlayers) {
    return 0;
  }

  const isPenalizedRoller = isNeutralRoller
    || checkIfNeutralPlayer(rollingPlayer?.id)
    || checkIfBotPlayer(rollingPlayer);
  if (!isPenalizedRoller || getBotD6MinRoll(rollingPlayer, targetPlayers) >= MAX_D6) {
    return 0;
  }

  const targets = Array.isArray(targetPlayers) ? targetPlayers : [targetPlayers];
  const isAgainstPlayerWithAdvantage = targets.some((target) => target && target.hasLowRatingAdvantage);

  return isAgainstPlayerWithAdvantage ? LOW_RATING_ADVANTAGE_DAMAGE_DICE_FACE_PENALTY : 0;
};
